<template>
  <div>
    <div class="fake-header" style="height: 80px;width: 100%; background: #218BEF"></div>
    <div class="main">
      <div class="dawan-header">
        <div class="content header-info">
          <img src="../../static/img/dawan/headtextbg.png" alt="">
          <div class="chinese-title">服务简介</div>
          <div class="text">发布支持港澳青年来天河发展有关新闻、政策、办事指引，为港澳青年来天河发展提供便利服务和有力保障，支持港澳青年来穗施展才华、追梦圆梦，促进港澳青年更好融入粤港澳大湾区建设和发展。</div>
        </div>
      </div>
      <div class="content">
        <div class="policy">
          <div class="title">
            <span class="text">相关政策及解读</span>
            <span class="more">更多>></span>
          </div>
          <div class="policy-list">
            <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_8684827.html')">
              <span>广东省人力资源和社会保障厅、广东省财政厅、国家税务局...</span>
              <span>2022-11-28</span>
            </div>
            <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_8529665.html')">
              <span>关于征求《广州市天河区深化支持港澳青年创新创业发...</span>
              <span>2022-07-02</span>
            </div>
            <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_8157756.html')">
              <span>“粤港澳大湾区”连续六年写进政府工作报告</span>
              <span>2022-03-07</span>
            </div>
            <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_7823030.html')">
              <span>大湾区政策 《关于支持港澳青年在粤港澳大湾区就.. </span>
              <span>2021-10-09</span>
            </div>
            <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/xgzcjjd/content/post_7802952.html')">
              <span>一图读懂广州市粤港澳大湾区个人所得税优惠政策财政补贴申报 (境外高端人才)  </span>
              <span>2021-09-01</span>
            </div>
          </div>
        </div>
        <div class="question">
          <div class="title">
            <div class="text">
              <span class="active">热点聚焦</span>
              <span>常见问题</span>
            </div>
            <span class="more">更多>></span>
          </div>
          <div class="ques-cont">
            <div class="cont hot">
              <div class="hot-item">
                <div class="swiper img-swiper">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img src="../../static/img/dawan/dawan_rdzx1.png" alt="">
                      <div class="swiper-tooltip">稳居第一！天河针对专业法治需求推动粤港澳三地规划</div>
                    </div>
                    <div class="swiper-slide">
                      <img src="../../static/img/dawan/dawan_rdzx2.png" alt="">
                      <div class="swiper-tooltip">T.I.T智慧园开园！打造大湾区“五乐”一体化粤港澳青年创新创业园区</div>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination3"></div>
                  <div class="swiper-button-next-img swiper-button-next3"></div>
                  <div class="swiper-button-prev-img swiper-button-prev3"></div>
                </div>

              </div>
              <div class="hot-item">
                <div class="policy-list" style="margin-top: 0;">
                  <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8824611.html')">
                    <span>稳居第一！天河针对专业法治需求推动粤港澳三地规划</span>
                    <span>2023-01-12</span>
                  </div>
                  <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8684764.html')">
                    <span>总投资86.54亿美元!天河成港澳青年筑梦“第一扇窗”</span>
                    <span>2022-11-09</span>
                  </div>
                  <div class="policy-item" @click="openNewPage('https://mp.weixin.qq.com/s/AYNB-e-ZuOX06P_g4YzBFg')">
                    <span>T.I.T智慧园开园!打造大湾区“五乐”一体化粤港澳青年创新创业园区 </span>
                    <span>2022-06-24</span>
                  </div>
                  <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8529640.html')">
                    <span>最高500万元安家费，广州天河升级港澳青年双创</span>
                    <span>2022-07-26</span>
                  </div>
                  <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8103061.html')">
                    <span>天河政务助力打造港澳青年创新创业“湾区最佳体验地...  </span>
                    <span>2022-03-01</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="cont hot" style="display: none;">
              <div class="hot-item">
                <div class="swiper img-swiper">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img src="../../static/img/dawan/dawan_cjwt1.png" alt="">
                      <div class="swiper-tooltip">手把手教你！港澳青年在奥港澳大湾区就业创业政策解读来了</div>
                    </div>
                    <div class="swiper-slide">
                      <img src="../../static/img/dawan/dawan_cjwt2.png" alt="">
                      <div class="swiper-tooltip">手把手教你！港澳青年在奥港澳大湾区就业创业政策解读来了</div>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination3"></div>
                  <div class="swiper-button-next-img swiper-button-next3"></div>
                  <div class="swiper-button-prev-img swiper-button-prev3"></div>
                </div>
              </div>
              <div class="hot-item">
                <div class="policy-list" style="margin-top: 0;">
                  <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/rdjj/content/post_8824611.html')">
                    <span>稳居第一！天河针对专业法治需求推动粤港澳三地规划</span>
                    <span>2023-01-12</span>
                  </div>
                  <div class="policy-item" @click="openNewPage('https://mp.weixin.qq.com/s/I1bcaXYMnYC1gASqpqAIiA')">
                    <span>手把手教你!港澳青年在粤港澳大湾区就业创业政策解读来了</span>
                    <span>2022-11-28</span>
                  </div>
                  <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/cjwt/content/post_8157764.html')">
                    <span>“数”说天河区港澳青年之家总部基地2021这一年 </span>
                    <span>2022-05-29</span>
                  </div>
                  <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/cjwt/content/post_7940555.html')">
                    <span>港澳台和外国的参保人如何申领广州社保卡，最新攻略.. </span>
                    <span>2021-11-30</span>
                  </div>
                  <div class="policy-item" @click="openNewPage('http://www.thnet.gov.cn/zwfw/zdfw/zcgaqnfz/cjwt/content/post_7403636.html')">
                    <span>湾区来内地就业的港澳居民，这个问题一定要关注！</span>
                    <span>2021-06-16</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-one">
          <div class="tab-item">
            <div class="tab-item-img">
              <img src="../../static/img/index/person.png" alt="">
            </div>
            <div class="tab-item-text">
              港澳居民政务服务事项
            </div>
            <div class="active-line">
              <div class="triangle"></div>
            </div>
          </div>
          <div class="tab-item active">
            <div class="tab-item-img">
              <img src="../../static/img/index/legal.png" alt="">
            </div>
            <div class="tab-item-text">
              港澳企业政务服务事项
            </div>
            <div class="active-line">
              <div class="triangle"></div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="one-cont">
          <div class="cont" style="display: none;">港澳居民政务服务事项</div>
          <div class="cont">
            <div class="tab-two">
              <div class="tab-item">
                <div class="icon">
                  <img src="../../static/img/index/fr-icon1.png">
                </div>
                <p>全部</p>
              </div>
              <div class="tab-item">
                <div class="icon">
                  <img src="../../static/img/index/fr-icon2.png">
                </div>
                <p>企业开办</p>
              </div>
              <div class="tab-item">
                <div class="icon">
                  <img src="../../static/img/index/fr-icon3.png">
                </div>
                <p>用工招聘</p>
              </div>
              <div class="tab-item">
                <div class="icon">
                  <img src="../../static/img/index/fr-icon4.png">
                </div>
                <p>缴费纳税</p>
              </div>
              <div class="tab-item active">
                <img src="../../static/img/index/fr-icon5.png">
                <p>生产经营</p>
              </div>
              <div class="tab-item">
                <div class="icon">
                  <img src="../../static/img/index/fr-icon6.png">
                </div>
                <p>破产注销</p>
              </div>
            </div>
            <div class="two-cont">
              <div class="cont" style="display: none;">全部</div>
              <div class="cont" style="display: none;">企业开办</div>
              <div class="cont" style="display: none;">用公招聘</div>
              <div class="cont" style="display: none;">缴费纳税</div>
              <div class="cont">
                <div class="header-title">
                  <div class="title">
                    <span>办事服务</span>
                  </div>
                  <div class="btngroup">
                    <div>
                      <input type="checkbox" name="level" style="vertical-align: -2px;">
                      <label for="level" class="checklabeltext">仅显示本级</label>
                    </div>
                    <div class="btn-group">
                                        <span class="dropdown-toggle droptext" data-toggle="dropdown"
                                              aria-haspopup="true" aria-expanded="false">
                                            全部部门<span class="caret"></span>
                                        </span>
                      <ul class="dropdown-menu">
                        <li><a href="#">部门</a></li>
                        <li><a href="#">部门</a></li>
                      </ul>
                    </div>
                    <div class="btn-group">
                                        <span class="dropdown-toggle droptext" data-toggle="dropdown"
                                              aria-haspopup="true" aria-expanded="false">
                                            全部对象<span class="caret"></span>
                                        </span>
                      <ul class="dropdown-menu">
                        <li><a href="#">对象</a></li>
                        <li><a href="#">对象</a></li>
                      </ul>
                    </div>
                    <div class="btn-group">
                                        <span class="dropdown-toggle droptext" data-toggle="dropdown"
                                              aria-haspopup="true" aria-expanded="false">
                                            全部类型<span class="caret"></span>
                                        </span>
                      <ul class="dropdown-menu">
                        <li><a href="#">类型</a></li>
                        <li><a href="#">类型</a></li>
                      </ul>
                    </div>
                    <div class="search-form">
                      <div class="input-group">
                                            <span class="input-group-btn">
                                                <button class="btn btn-default" type="button"></button>
                                            </span>
                        <input type="text" class="form-control" placeholder="请输入您要办理的事项">

                      </div>
                    </div>
                  </div>

                </div>
                <div class="service-table dawan-servive-table">
                  <div class="service-head">
                    <div>服务事项名称</div>
                    <div>解读材料</div>
                    <div>操作</div>
                  </div>
                  <div class="service-body">
                    <div class="service-item">
                      <div>涉外收养登记</div>
                      <div>市民政局</div>
                      <div>
                        <a href="">办事指南</a>
                        <a href="">在线办理</a>
                      </div>
                    </div>
                    <div class="service-item">
                      <div>华侨及居住在香港、澳门、台湾地区的中国公民在内地收养登记</div>
                      <div>市民政局</div>
                      <div>
                        <a href="">办事指南</a>
                        <a href="">在线办理</a>
                      </div>
                    </div>
                    <div class="service-item">
                      <div>撤销中国公民收养登记</div>
                      <div>市民政局</div>
                      <div>
                        <a href="">办事指南</a>
                        <a href="">在线办理</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="page">
                  <ul class="pagination">
                    <li class="previous disabled">
                      <a href="#" aria-label="Previous">
                      </a>
                    </li>
                    <li class="active"><a href="#">1</a></li>
                    <li><a href="#">2</a></li>
                    <li><a href="#">3</a></li>
                    <li><a href="#">4</a></li>
                    <li><a href="#">...</a></li>
                    <li><a href="#">8</a></li>
                    <li class="next">
                      <a href="#" aria-label="Next">
                      </a>
                    </li>
                  </ul>
                  <ul class="page-length list-inline">
                    <li><span>跳至</span></li>
                    <li>
                      <input type="text" class="form-control">
                    </li>
                    <li><span>页</span></li>
                  </ul>
                </div>
              </div>
              <div class="cont" style="display: none;">破产注销</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script src="../../static/js/global.js"></script>
<script src="../../static/js/common.js"></script>
<script src="../../static/js/index.js"></script>

<script>
export default {
  name: "Dawan",
  methods: {
    openNewPage(url) {
      window.open(url)
    },
  },
}
</script>

<style>

@import "../../static/js/vendor/swiper/swiper-bundle.min.css";
@import "../../static/css/bootstrap.min.css";
@import "../../static/css/common.css";
@import "../../static/css/global.css";
@import '../../static/css/dawan.css';


</style>



// WEBPACK FOOTER //
// Dawan.vue?0173a2e0